import { Routes, Route, Navigate } from "react-router-dom";
import { CorporatePortalLayout } from "./CorporatePortalLayout";
import CorporateHomePage from "./pages/CorporateHomePage";
import CorporateAboutPage from "./pages/CorporateAboutPage";
import CorporateSolutionsPage from "./pages/CorporateSolutionsPage";
import CorporateCasesPage from "./pages/CorporateCasesPage";
import CorporateNewsPage from "./pages/CorporateNewsPage";
import CorporateNewsDetailPage from "./pages/CorporateNewsDetailPage";
import CorporateContactPage from "./pages/CorporateContactPage";

/** longfans.com 单位门户（测试模式开启时全站替换） */
export default function CorporatePortalApp() {
  return (
    <Routes>
      <Route element={<CorporatePortalLayout />}>
        <Route path="/" element={<CorporateHomePage />} />
        <Route path="/about" element={<CorporateAboutPage />} />
        <Route path="/solutions" element={<CorporateSolutionsPage />} />
        <Route path="/cases" element={<CorporateCasesPage />} />
        <Route path="/news" element={<CorporateNewsPage />} />
        <Route path="/news/:newsId" element={<CorporateNewsDetailPage />} />
        <Route path="/contact" element={<CorporateContactPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
